import React from "react";
import { Body } from "@components";
import locale from "@bonliva-crm/locale";
import { LinearProgress } from "@material-ui/core";

export const Uploading = () => {
  return (
    <div style={{ marginBottom: 16 }}>
      <Body color="textSecondary" style={{ textAlign: "center" }}>
        {locale.Uploading}
      </Body>

      <LinearProgress color="primary" />
    </div>
  );
};
